import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { coerceToString } from './coerce';

@Component({
  selector: 'rt-assistant-cell-text',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `{{ display() }}`,
})
export class AssistantCellTextComponent {
  public static readonly NgInputs = [<const>'value'];

  protected readonly display = computed(() => coerceToString(this.value()));

  public readonly value = input<unknown>();
}
